import request from '@/utils/request'
const qs = require('qs')

// 获取站点开通统计
export function getStationOpenStatistics (data) {
  return request({
    url: '/ooh-rim/v1/station/getstationopenstatistics',
    method: 'post',
    data: qs.stringify(data),
    timeout: 200000
  })
}
// 获取站点SVG
export function getStationSvgByStationId (data) {
  return request({
    url: '/ooh-rim/v1/stationgraph/getStationSvgByStationId',
    method: 'post',
    data: qs.stringify(data),
    timeout: 200000
  })
}
// 获取图例
export function getIcon (data) {
  return request({
    url: '/ooh-draw/svg/geticon',
    method: 'post',
    data: qs.stringify(data)
  })
}
